import { createAction } from '@reduxjs/toolkit';

export const giftCardReconciledAfterCartEntryChange = createAction(
  'carts/giftCardReconciledAfterCartEntryChange'
);
